import React from "react";

export interface IFavoritesContext {
  favorites: Set<string>;
}

export const FavoritesContext = React.createContext<IFavoritesContext>({ favorites: new Set<string>() });
